import React from "react";
import Banner from "../components/Portfolio/Banner";
import OurPort from "../components/Portfolio/OurPort";

function Portfolio() {
  return (
    <main id="portfolio-page">
      <Banner />
      <OurPort />
    </main>
  );
}

export default Portfolio;
